import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Link } from "react-router-dom";
import { config } from "../../../config/index";
import { GET, newFetch } from "../../../helpers/fetch";
import themeImages from "../../../helpers/images";
import "./styles.css";
const { MANPOWER_ELEAVE_HRSS } = config;

const Shortcuts = ({ client, defaultSiteData, t }) => {
  const [shortcuts, setShortcuts] = React.useState([]);
  const [width, setWidth] = React.useState(window.innerWidth);

  React.useEffect(() => {
    if (defaultSiteData && client) {
      filterShortcuts();
    }
  }, [defaultSiteData, client]);

  const fetchShortcuts = async () => {
    let api_path = `/shortcuts`;
    try {
      let response = await newFetch(GET, api_path);

      if (response.success) {
        setShortcuts(response.data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const filterShortcuts = async () => {
    if (!defaultSiteData) return; // ✅ Prevents running before data is available
    const shortcutData = [
      {
        id: 1,
        title: t("Timeclock"),
        url: "time-clock",
        isStatic: true,
        imgUri: themeImages.timeclock,
        show: client?.enable_smart_scheduler || false,
        isThirdParty: false,
      },
      {
        id: 2,
        title: t("Preferred Schedule"),
        url: "preferred-schedule",
        isStatic: false,
        imgUri: themeImages.schedule,
        show: defaultSiteData?.enable_preferred_schedule || false, // ✅ Now safe to use
        isThirdParty: false,
      },
      {
        id: 3,
        title: "Catalogue",
        url: "catalogue",
        isStatic: false,
        imgUri: themeImages.catalog,
        show: client?.enable_catalogue || false,
        isThirdParty: false,
      },
      {
        id: 4,
        title: "Delivery Order",
        url: "delivery-order",
        isStatic: false,
        imgUri: themeImages.deliveryOrder,
        show: client?.enable_delivery_order || false,
        isThirdParty: false,
      },
      {
        id: 5,
        title: t("Leave"),
        url: "leave",
        isStatic: false,
        imgUri: themeImages.leaveFilling,
        show: client?.enable_leave_credits || false,
        isThirdParty: false,
      },
      {
        id: 6,
        title: t("Claims"),
        url: "claims",
        isStatic: false,
        imgUri: themeImages.claims,
        show: client?.enable_claims || false,
        isThirdParty: false,
      },
      {
        id: 7,
        title: t("eDocs"),
        url: "edocs",
        isStatic: false,
        imgUri: themeImages.eDocs,
        show: client?.enable_edocs || false,
        isThirdParty: false,
      },
      {
        id: 8,
        title: t("Communications"),
        url: "communications",
        isStatic: false,
        imgUri: themeImages.communications,
        show: client?.enable_communication || false,
        isThirdParty: false,
      },
      {
        id: 9,
        title: "Rewards",
        url: "rewards",
        isStatic: false,
        imgUri: themeImages.rewards,
        show: client?.enable_reward || false,
        isThirdParty: false,
      },
      {
        id: 10,
        title: "eLeave",
        url: `${MANPOWER_ELEAVE_HRSS}`,
        isStatic: false,
        imgUri: themeImages.leave,
        show: client?.enable_eleave_hrss || false,
        isThirdParty: true,
      },
    ];

    if (client.enable_smart_scheduler === true) {
      setShortcuts(shortcutData); // No filtering if smart scheduler is enabled
    } else {
      const newShortcuts = shortcutData.filter((item) => {
        if (item.title === "Preferred Schedule") {
          return defaultSiteData?.enable_preferred_schedule === true;
        }
        if (item.title === "Timeclock") {
          return true;
        }
        return true;
      });
      setShortcuts(newShortcuts);
    }
  };

  React.useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const columns = width < 600 ? 4 : 8;

  const gridStyle = {
    display: "grid",
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    width: "98%",
    marginTop: "20",
    paddingLeft: 11,
  };

  return (
    <div style={gridStyle}>
      {shortcuts.map(
        (item, index) =>
          item.show && (
            <div key={index} className="dashboard__shortcuts-wrapper">
              {item.isThirdParty ? (
                <a href={item.url} target="_blank" rel="noopener noreferrer">
                  <img
                    src={item.imgUri}
                    alt={item.title}
                    className="dashboard__shortcuts-image"
                  />
                  <p>{item.title}</p>
                </a>
              ) : (
                <Link to={`/${item.url}`}>
                  <img
                    src={item.imgUri}
                    alt={item.title}
                    className="dashboard__shortcuts-image"
                  />
                  <p>
                    {item.title == "Communication"
                      ? `Commu\u00ADnication`
                      : item.title}
                  </p>
                </Link>
              )}
            </div>
          )
      )}
    </div>
  );
};

export default Shortcuts;
